import React, { FC } from 'react';
import { useField } from 'formik';
import styles from './Inputs.module.scss';

export interface TextFieldProps {
  label?: string;
  name: string;
}

export const TextField: FC<TextFieldProps> = ({ label, ...props }) => {
  const [field, meta, helpers] = useField(props);

  return (
    <div className={styles.formControl}>
      {label && <label htmlFor={props.name}>{label}</label>}
      <input {...field} {...props} type='text' />
      {meta.touched && meta.error ? <div className='error'>{meta.error}</div> : null}
    </div>
  );
};
export default TextField;
